/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locales_De_DeInputs */

const en_us2_locales_de_de = /** @type {(inputs: Locales_De_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const pt_br2_locales_de_de = /** @type {(inputs: Locales_De_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const es_419_locales_de_de = /** @type {(inputs: Locales_De_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const pt_pt2_locales_de_de = /** @type {(inputs: Locales_De_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const fr_fr2_locales_de_de = /** @type {(inputs: Locales_De_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const de_de2_locales_de_de = /** @type {(inputs: Locales_De_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const it_it2_locales_de_de = /** @type {(inputs: Locales_De_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

/**
* | output |
* | --- |
* | "Deutsch" |
*
* @param {Locales_De_DeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const locales_de_de = /** @type {((inputs?: Locales_De_DeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locales_De_DeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_locales_de_de(inputs)
	if (locale === "es-419") return es_419_locales_de_de(inputs)
	if (locale === "pt-PT") return pt_pt2_locales_de_de(inputs)
	if (locale === "fr-FR") return fr_fr2_locales_de_de(inputs)
	if (locale === "de-DE") return de_de2_locales_de_de(inputs)
	if (locale === "it-IT") return it_it2_locales_de_de(inputs)
	return en_us2_locales_de_de(inputs)
});
export { locales_de_de as "locales.de_de" }